// types
import { AppDispatch, RootState } from '../store';

// slice actions
import {
    disableAppMain as actionDisableAppMain,
    enableAppMain as actionEnableAppMain,
    disableFacebookExceptioModal as actionDisableFacebookExceptionModal,
    enableFacebookExceptioModal as actionEnableFacebookExceptionModal,
    setIsMainActive
} from '../slices/slice-app-main';


export const disableAppMain = () => {

    return (dispatch: AppDispatch) => {
        dispatch( actionDisableAppMain() );
    };
};

export const enableAppMain = () => {

    return (dispatch: AppDispatch) => {
        dispatch( actionEnableAppMain() );
    };
};

export const disableFacebookExceptioModal = () => {

    return (dispatch: AppDispatch) => {
        dispatch( actionDisableFacebookExceptionModal() );
    };
};

export const enableFacebookExceptioModal = () => {

    return (dispatch: AppDispatch) => {
        dispatch( actionEnableFacebookExceptionModal() );
    };
};

export const toggleisAppMainActive = () => {

    return (dispatch: AppDispatch, getState: () => RootState) => {

        const { isMainActive } = getState().appMain;
        dispatch( setIsMainActive(!isMainActive) );
    };
};
